import React, { FC } from 'react';
import notFoundImg from '@src/assets/image/404@2x.png';
import styles from './index.module.less';
import { AppBody } from '../../components/app-body';

export const ErrorPage: FC = () => (
  <AppBody title="页面出错了">
    <div className={styles.container}>
      <img src={notFoundImg} alt="" />
      <p className={styles.tip}>页面出错了</p>
    </div>
  </AppBody>
);
